'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = exports.PERMISSIONS = undefined;

var _icons;

exports.getPermission = getPermission;
exports.parsePermission = parsePermission;
exports.getPermissionIcon = getPermissionIcon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icons = require('../../components/Common/Icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
/* injects from baggage-loader */

var PERMISSIONS = exports.PERMISSIONS = {
  PUBLIC: 'PUBLIC',
  UNLISTED: 'UNLISTED',
  PRIVATE: 'PRIVATE'
};

var icons = exports.icons = (_icons = {}, _defineProperty(_icons, PERMISSIONS.PRIVATE, _react2.default.createElement(_Icons.PermissionPrivate, { width: '14', height: '14' })), _defineProperty(_icons, PERMISSIONS.UNLISTED, _react2.default.createElement(_Icons.PermissionUnlisted, { width: '14', height: '14' })), _defineProperty(_icons, PERMISSIONS.PUBLIC, null), _icons);

function getPermission() {
  var project = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var userPublicProjects = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  if (project.public) {
    if (userPublicProjects.hasOwnProperty(project.id)) {
      return PERMISSIONS.PUBLIC;
    }
    return PERMISSIONS.UNLISTED;
  }
  return PERMISSIONS.PRIVATE;
}

function parsePermission(permission) {
  var isPublic = permission === PERMISSIONS.PUBLIC || permission === PERMISSIONS.UNLISTED;
  var isListed = permission === PERMISSIONS.PUBLIC;
  return {
    isPublic: isPublic,
    isListed: isListed
  };
}

function getPermissionIcon(permission) {
  return icons[permission];
}


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/projectPermissions.js
// module id = 139
// module chunks = 1